<template>
  <IconLucideCircleChevronLeft />
</template>
